// The one-time link a Scout's web view opens to sign its owner in to MyPolaris
// (vortex-api lib/scoutWebSignIn.ts builds it): /auth/scout#t=<token>&next=<path>.
// The token rides in the fragment, which never reaches a server, log or Referer.
//
// @docs:
//   - docs/core/architecture/SCOUT_MYPOLARIS_SIGN_IN.md

export interface ScoutLink {
  token: string | null;
  next: string;
}

/** A path on this site to land on; anything that could leave it becomes the dashboard (same rule as the API). */
export function safeNext(raw: string | null | undefined): string {
  const s = (raw ?? '').trim();
  if (!s.startsWith('/') || s.startsWith('//') || s.startsWith('/\\') || s.length > 2000) return '/dashboard';
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c <= 0x20 || c === 0x7f) return '/dashboard';
  }
  return s;
}

export function parseScoutLink(hash: string): ScoutLink {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('t');
  return { token: token && token.length >= 16 && token.length <= 200 ? token : null, next: safeNext(params.get('next')) };
}

/** Leave for [path] without keeping this page (and its spent token) in history. */
export function leaveTo(path: string): void {
  window.location.replace(path);
}
